import React, { useEffect, useCallback, useRef, useMemo, useState } from 'react';
// import AgGrid from "./AgGrid"
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { columnwithDefs } from "./columnDefs_vehicles";
import Constants from "./Masters_constants";
import redirectURL from "../redirectURL";
import EditItem from './EditItem'
import DeletePartner from './deleteItem'
import SweetAlert from 'react-bootstrap-sweetalert';
import { getHyphenDDMMMYYYYHHMM } from '../common/utils';
import { format } from 'date-fns';
import Select from 'react-select';
import BulkUploadModal from './BulkUploadModal.js';
import EditLogsConsignments from './editlogsConsignments.js';
import CustomDialogForMasterEditLogs from './CustomDialogForMasterEditLogs.js';
import TransporterDropdownEditor from './tptdropdownEditor.js';
import {SubmitBtn, isValidPositiveNumber } from "../common/utils.js";





function Masters() {
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
    var [rowData, setRowData] = useState([])
    var [validEntitiesOptions, setValidEntitiesOptions] = useState([])
    var [courierPartnerList, setCourierPartnerList] = useState([])
    const [tptRecords, setTptRecords] = useState([])
    
    var [columnDefs1, setColumnDefs1] = useState([
        {
                   headerName: "",
                   field: "submit_btn",
                   colId: "submit_btn",
                   width: 80,
                   filter:false, 
                   resizable: true,
                   cellRendererSelector: function (param) {
                       try {
                           // Check if any edit was made (i.e., if isEdited is true)
                          
                               return {
                                   component: SubmitBtn,
                                   params: {
                                       onClickEditDeliveryDate: onClickSaveTPTAlloc
                                   }
                               };
                         
                       } catch (err) {
                           console.log(err);
                           return null;
                       }
                   },
               },
         {
                    headerName: "",
                    field: "edit_logs",
                    colId: "edit_logs",
                    width: 50,
                    pinned: "left",
                    filter:false,
                    cellRendererSelector: function (param) {
                        try {
                            if (param.data._id != null && param.data._id != undefined) {
                                // if(tabName.value === "active"){
                                    return {
                                        component: EditLogsConsignments,
                                        params: {
                                            onClickActive: onClickEditLogs,
                                            iconType: "edit",
                                            tooltip: "Edit Logs",
                                            disabled: (param.data.is_updated ===0 || param.data.is_updated === undefined || param.data.is_updated ===null)
        
                                        }
                                    // };                           
                                }
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    },
                    cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
                    headerClass: 'bold-header'
                },

    ])
    const TransporterDropdown = (props) => {
        return (
          <select
            autoFocus
            value={props.value}
            onChange={(e) => props.api.stopEditing(false)}
            onBlur={() => props.api.stopEditing(false)}
            style={{
              marginTop: '6px', // drop it down slightly
              padding: '4px',
              width: '100%',
              fontSize: '13px',
              border: '1px solid #ccc',
            }}
          >
            {props.colDef.cellEditorParams.values.map((val, idx) => (
              <option key={idx} value={val}>
                {val}
              </option>
            ))}
          </select>
        );
      };
   
    var tptAllocMasterColumns1 = [
        {
            headerName: "Source Pincode",
            field: "consigner_pincode",
            width: 142,
            filter: true,
            resizable: true
        },
        {
            headerName: "Source City",
            field: "consigner_city",
            width: 142,
            filter: true,
            resizable: true
        },
        {
            headerName: "Destination Pincode",
            field: "consignee_pincode",
            width: 200,
            filter: true,
            resizable: true
        },

        {
            headerName: "Destination City",
            field: "consignee_city",
            width: 180,
            filter: true,
            resizable: true

        },


        {
            headerName: "Weight in KG",
            field: "weight",
            width: 140,
            filter: true,
            editable: true,
            resizable: true,
            valueSetter: (params) => {
                const newValue = params.newValue;
              
                const isNumeric = /^\d+(\.\d+)?$/.test(newValue);
                const parsedValue = parseFloat(newValue);
              
              return isNumeric && parsedValue > 0
                ? (params.data[params.colDef.field] = parsedValue, true)
                : (alert("Please enter a numeric value greater than 0."), false);

              }
              
        },
        {
            headerName: "Transporter 1",
            field: "tpt_name_1",
            width: 180,
            filter: true,
            editable: true,
            resizable: true,
            cellEditor:"agSelectCellEditor",
            cellEditorParams:{
                values: tptRecords,
            }
        },
        {
            headerName: "Transporter 2",
            field: "tpt_name_2",
            width: 180,
            filter: true,
            editable: true,
            resizable: true,
            cellEditor:"agSelectCellEditor",
            cellEditorParams:{
                values: tptRecords
            }
        },
       

    ]
    var localStorageEmail = localStorage.getItem("email")
    

    var columnDefs = useMemo(()=> ([...columnDefs1, ...tptAllocMasterColumns1]), [tptRecords])


    // var [showloaderbg, setshowloaderbg] = useState("show-m");
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    var [showloader, setshowloader] = useState("show-m");
    var [showAddSlider, setshowAddSlider] = useState("");
    var [overlay, setoverlay] = useState("show-n");
    var [uniqueId, setUniqueId] = useState();
    var [sliderText, setSliderText] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    const [weightError, setWeightError] = useState("");
   
    const [transporter, setTransporter] = useState({
        consigneePincode: '',
        consignerPincode: '',
        consigneeCity:'',
        consignerCity:'',
        entity: '',
        weight: '',
        tpt_name_1:'',
        tpt_name_2:''
       
    })
    const [existingData, setExistingData] = useState({
        consigneePincode: '',
        consignerPincode: '',
        entity: '',
        weight: '',
        tpt_name_1:'',
        tpt_name_2:''
    })

    // var modules = useState(AllModules);
    var [show, setShow] = useState(false);
    var [basicType, setBasicType] = useState("");
    var [basicTitle, setBasicTitle] = useState("");
    var [reload, setReload] = useState(false);
    var [deleteConfirmationSlide, setDeleteConfirmationSlide] = useState("");
    var [deleteRowData, setDeleteRowData] = useState("");
    var [invoiceLength, setInvoiceLength] = useState("");
    const [editLogsData, setEditLogsData] = useState([])
    const [filteredLog, setFilteredLog] = useState([])
    const [editLogsModalOpen, setIsEditLogsModalOpen] = useState(false)
    const [emailError, setEmailError] = useState('');
    const [mobileError, setMobileError] = useState('');
    const entity = useRef({label:"Legrand", value:"Legrand"}); 
   

    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            resizable: true,
            sortable: true,
            filter: true,
            editable: false

        };
    }, []);

    var onGridReady = (params) => {
        // gridApi = params.api;
        // gridColumnApi = params.columnApi;
        // gridApiRef.current = params.api; 
        // gridColumnApiRef.current = params.columnApi;
    }

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const getCurrentFormattedDate = () => {
        const date = new Date();
        return format(date, 'dd-MM-yyyy');
    };

    const getCurrentISODate = () => {
        const date = new Date();
        return date.toISOString();
    };

    const handleEditable = (params) => {
        setRowData(prevUsers =>
    prevUsers.map(row =>
      row._id === params.data._id ? { ...row, disabled:false  } : row
    )
  );
    }

    useEffect(() => {
        setTimeout(() => {
            // setshowloaderbg("show-n")
            setshowloader("show-n")
        }, 2000)
        
        loadData(entity.current.value);

        // 
    }, [])
    useEffect(() => {
        const fetchData = async () => {
            try {
                const entities = await redirectURL.post('/consignments/getEntities', {});
                const entitiesArr = entities.data[0].master_data;
                const validEntities = entitiesArr.map(e => ({ label: e, value: e }));
    
                setValidEntitiesOptions(validEntities);
    
                const response = await redirectURL.post('/consignments/getTransportersList');
                const records = response.data.tptMaster;
    
                const tptNames = records.map(e => e.transporter_name);
                setTptRecords(tptNames)
    
                const tptNamesList = tptNames.map((name) => ({ label: name.toUpperCase(), value: name }));
    
                setCourierPartnerList(tptNamesList);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        fetchData();  // Call the async function
    }, []);  // Empty dependency array, so this effect only runs once when the component mounts
    
     const onClickEditLogs = (e) => {
            //console.log(e, "eeee1234");
           
            // setOrginalDetailsForEdit(e.data)
            var params = {
                unique_id: e.data._id,
                master_type:"tpt_allocation"
            }
           
            // let selectedSource = e.data.source_city
            redirectURL.post("/consignments/getMasterEditLogsData", params)
            .then((response) => {
                if (response.data.status == 'Success') {
                    //console.log(response, "editlogsresp");
                    if((response.data.edit_logs_data).length>0){
                        setEditLogsData(response.data.edit_logs_data); // Store all logs
                    setFilteredLog(response.data.edit_logs_data[0]); // Default to first log
                    setIsEditLogsModalOpen(true);
                    }else{
                        setShow(true);
                        setTitle("No edit logs are currently available for this customer.");
                        setType("danger")
                        setoverlay("show-n")
                    }
                    
                }
            })
            .catch(function (e) {
                //console.log("Error ", e)
            })  
          
    
            // if(e.data.tracking_type === "FTL"){
            //     setshowAddForm3('slider-translate-30p');
            // } else {
            //     // setshowAddForm("slider-translate-30p");
            //     setshowAddForm3('slider-translate-30p');
            // }
            setoverlay("show-m");
        };

    var loadData = async (entityFilter) => {
        const parameters = { entity: entityFilter };
        await redirectURL.post('/getTptAllocDetails', parameters)
            .then(response => {
                if (response.data.status == "success") {
                    const updatedRecords = response.data.records.map(record => ({
                        ...record,
                        disabled: true
                    }));
                    setRowData(updatedRecords);
                    setshowloader("show-n");

                    // setInvoiceLength(response.data.records.length)

                }
                // setshowloaderbg("show-n" );

            })
            .catch(error => console.error('Error fetching data:', error));
           
        
    }
    var onClickDeleteItem = async (rownode) => {
        // console.log("Rownode Update", rownode);
        setDeleteConfirmationSlide("slide95")
        setoverlay("show-m")
        setDeleteRowData(rownode)
    };

    var onsubmitdelete = async (rownode) => {
        // console.log("Rownode Update", rownode);
        var params = {
            row_id: deleteRowData.data._id
        }

        try {
            const resp = await redirectURL.post('/deleteLocationDetails', params);

            if (resp.data.status === "success") {
                setDeleteConfirmationSlide("")
                setoverlay("show-n");
                setshowloader("show-n");
                setShow(true);
                setBasicTitle("Invoice Deleted Successfully");
                setBasicType("success");
                loadData(entity.current.value);
            }
        } catch (error) {
            console.error("Error deleting vehicle details:", error);
        }
    };
    var hideDeleteSubmit = () => {
        setDeleteConfirmationSlide("");
        setoverlay("show-n");

    }

    var showAddBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m")
        setSliderText("Add Transporter Allocation");
        setTransporter({
            consigneePincode: '',
            consignerPincode: '',
            consigneeCity:'',
            consignerCity:'',
            entity: '',
            weight: '',
            tpt_name_1:'',
            tpt_name_2:''
        })

        setIsEditMode(false);

    }

    var onClickEditBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m");
        setSliderText("Edit Customer");
        setUniqueId(rownode.data._id);
        setExistingData({
            consigneeCode: rownode.data.consignee_code,
            consigneeName: rownode.data.consignee_name,
            mobileNo: rownode.data.mobile_no,
            emailId: rownode.data.email_id,
        })
        

        setCustomer({
            consigneeCode: rownode.data.consignee_code,
            consigneeName: rownode.data.consignee_name,
            mobileNo:rownode.data.mobile_no,
            emailId: rownode.data.email_id,

        })

        setIsEditMode(true);
    }

    var hideAll = () => {
        setoverlay("show-n");
        setshowAddSlider("");
        setWeightError("")
    }
    const getChanges = () => {
        const changes = {}
        Object.keys(customer).forEach((key) => {
            if (customer[key] !== existingData[key]) {

                if (key === "consigneeCode") {
                    changes["consignee_code"] = customer[key]
                }
                if (key === "consigneeName") {
                    changes["consignee_name"] = customer[key]
                }
                if (key === "mobileNo") {
                    changes["mobile_no"] = customer[key]
                }
                if (key === "emailId") {
                    changes["email_id"] = customer[key]
                }
            }
        })
        return changes;
    }
   
    const compareObjects = (obj1, obj2) => {
        let changes = {};
    
        // List of keys to compare
        const keysToCompare = [
          'consigner_pincode',
          'consignee_pincode',
          'entity',
          'weight',
          'tpt_name_1',
          'tpt_name_2'
        ];
    
        keysToCompare.forEach((key) => {
          if (obj1[key] !== obj2[key]) {
            changes[key] = obj2[key]
            
          }
        });
    
        return changes;
      };

    var onClickSaveTPTAlloc  = async (rownode) =>{

        let params = {
            unique_id: rownode.data._id
        }

        let record;

        await redirectURL.post('/consignments/getTptAllocRecord', params).then((resp) => {
            if (resp.data.status == "success") {

                record = resp.data.tptAllocRecord[0];
              
            }
        });

        const { modified_date, created_by, created_date, ...tptDataWithoutMeta } = rownode.data;

        
        
        let compareChanges = compareObjects(record, tptDataWithoutMeta)

        let editedParams ={
            ...compareChanges
        }
        editedParams.unique_id= rownode.data._id;
        editedParams.master_type= "tpt_allocation";
        editedParams.email= decode(localStorageEmail)

        const {tpt_name_1, tpt_name_2} = editedParams;

        const bothEditedAndEqual = tpt_name_1 && tpt_name_2 && tpt_name_1 === tpt_name_2;

        // Check if only tpt_name_1 is edited and equals existing tpt_name_2
        const tpt1EditedEqualOldTpt2 = tpt_name_1 && (tpt_name_2 == null) && tpt_name_1 === record.tpt_name_2;

        // Check if only tpt_name_2 is edited and equals existing tpt_name_1
        const tpt2EditedEqualOldTpt1 = tpt_name_2 && (tpt_name_1 == null) && tpt_name_2 === record.tpt_name_1;

        if(bothEditedAndEqual || tpt1EditedEqualOldTpt2 || tpt2EditedEqualOldTpt1){
            setShow(true);
            setBasicTitle("Transporter 1 and Transporter 2 must be different. Please select distinct transporters.");
            setBasicType("danger");
            setReload(true)
            return;
        }
      
        


        
        // setLoader(true)
        await redirectURL.post('/saveTPTAllocMaster', editedParams).then((resp) => {
            
            if (resp.data.status == "Success") {
                setShow(true);
                setBasicTitle("Updated Transporter Allocation Data");
                setBasicType("success");
                setoverlay("show-n");
                loadData(entity.current.value);

                setshowAddSlider("");
                setshowloader("show-n");
                setTransporter({
                    consigneePincode: '',
                    consignerPincode: '',
                    consigneeCity:'',
                    consignerCity:'',
                    entity: '',
                    weight: '',
                    tpt_name_1:'',
                    tpt_name_2:''
                })
                setWeightError("")
                setIsEditMode(false);
                
            }else{
                setShow(true);
                setBasicTitle(resp.data.message);
                setBasicType("danger");
            }
        });
       
    }

    var saveMasterForm = async (e) => {
        e.preventDefault();
        let user_email = localStorage.getItem('email');
        // setshowloaderbg("show-m");
        const createdDate = getCurrentISODate();
        const tptError1 = transporter.consigneePincode && !/^\d{6}$/.test(transporter.consigneePincode);
        const tptError2 = transporter.consignerPincode && !/^\d{6}$/.test(transporter.consignerPincode);
        if(tptError1 || tptError2){
            setShow(true);
            setBasicTitle("Please enter the valid pincode values");
            setBasicType("danger");
            return;
        }

        setshowloader("show-m")
        if (isEditMode) {
            
            var changedFields = getChanges();
                // If either of these fields is not edited, pass only the edited fields
            var params = { ...changedFields };

            params.unique_id = uniqueId;
            params.master_type = "customer";
            params.email = decode(localStorageEmail)

         
        }

        else {
            var params = {
                consignerPincode: transporter.consignerPincode,
                consigneePincode: transporter.consigneePincode,
                consigneeCity: transporter.consigneeCity,
                consignerCity: transporter.consignerCity,
                // entity: transporter.entity.value,
                // weight: transporter.weight,
                // tptName1:transporter.tpt_name_1.value,
                // tptName2:transporter.tpt_name_2.value,
                // is_active: is_active,
                masterType: "tpt_allocation",
                email:decode(localStorageEmail)
            }

        }

        if (isEditMode) {
            
            await redirectURL.post('/updateCustomerMaster', params).then((resp) => {
                if (resp.data.status == "Success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setshowloader("show-n");
                    setIsEditMode(false);
                    setUniqueId("");
                    setShow(true);
                    setBasicTitle(resp.data.message);
                    setBasicType("success");
                    loadData(entity.current.value);
                    setCustomer({
                        consigneeCode: '',
                        consigneeName: '',
                        mobileNo: '',
                        emailId: ''
                    })
                   setMobileError("")
                   setEmailError("")
                }
            });
        } else {
            await redirectURL.post('/addTptAllocMaster', params).then((resp) => {
                if (resp.data.status == "Success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setshowloader("show-n");
                    setShow(true);
                    setBasicTitle("Added Transporter Allocation Data");
                    setBasicType("success");
                    loadData(entity.current.value);
                    setTransporter({
                        consigneePincode: '',
                        consignerPincode: '',
                        consigneeCity:'',
                        consignerCity:'',
                        entity: '',
                        weight: '',
                        tpt_name_1:'',
                        tpt_name_2:''
                    })

                    setIsEditMode(false);

                    setWeightError("")
                } else if (resp.data.status === "Failure") {
                    setoverlay("show-n");
                    setshowloader("show-n");
                    setIsEditMode(false);
                    setshowAddSlider("");
                    setShow(true);
                    setBasicTitle(resp.data.message);
                    setBasicType("danger");
                    setTransporter({
                        consigneePincode: '',
                        consignerPincode: '',
                        consigneeCity:'',
                        consignerCity:'',
                        entity: '',
                        weight: '',
                        tpt_name_1:'',
                        tpt_name_2:''
                    })
                   
                    setWeightError("")
                }
            }).catch(err => {
            });
        }
    };
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const onClickOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
        setoverlay("show-m")
    };

    const closeBulkUploadModal = () => {
        setShowBulkUploadModal(false);
        setoverlay("show-n")
    };



    
    const handleCloseModal = () => {
        setIsEditLogsModalOpen(false); // Close the modal
        setFilteredLog(null); // Clear filtered log
        setoverlay("show-n")
    };
    
    const handlePhoneInputChange = (e) => {
        const value = e.target.value;
        const isValidStart = /^[6-9][0-9]*$/;
    
        if (value === '' || (isValidStart.test(value) && value.length <= 10)) {
            setCustomer(prev => ({
                ...prev,
                mobileNo: value
            }));
    
            // Show error only if 1 to 9 digits entered
            if (value.length > 0 && value.length < 10) {
                setMobileError("Mobile number must be 10 digits.");
            } else {
                setMobileError("");
            }
        }
    };
    const handleWeight = (e) => {
        const value = e.target.value;
    
        // Validate if the input is numeric (only numbers)
        if (isValidPositiveNumber(value)) {
            setTransporter(prev => ({
              ...prev,
              weight: value
            }));
            setWeightError(""); // Clear the error message
          } else {
            setTransporter(prev => ({
                ...prev,
                weight: ""
              }));
            setWeightError("Please enter a valid weight value greater than 0"); // Show error
          }
      };

      const handleEntityWiseData=(e)=>{
        entity.current = e
                setshowloader("show-m")

        loadData(e.value)
      }
      const customStyles = {
        singleValue: (provided) => ({
          ...provided,
          fontSize: '14px', // Adjust the size as needed
        }),
        // Optional: reduce font size in dropdown options as well
        option: (provided) => ({
          ...provided,
          fontSize: '14px',
        }),
      };

    return (
        <div>
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={() => {
                        setShow(false)
                        if(reload ===true){
                            setReload(false)
                            window.location.reload()
                        }
                    }}>
                </SweetAlert>


            </div>
            <div className="container-fluid">
                {/* Row for Heading and Buttons */}
                <div className="row align-items-center justify-content-between mb-3">
                    {/* Heading */}
                    <div className="col-auto">
                        <h5 className="f18 d-flex align-items-center master-title">
                            <i className="icofont icofont-vehicle-delivery-van cus-i"></i>
                            &nbsp;Transporter Allocation Master
                        </h5>
                    </div>

                    {/* Buttons */}
                    <div className="col-auto d-flex">
                        {/* <button
                title="Bulk Upload"
                onClick={onClickOpenBulkUploadModal}
                className="btn btn-warning mr-2"
                type="button"
                style={{ padding: "8px 15px", height: "35px" }}
            >
                <i className="fa fa-upload"></i>&nbsp;Upload Locations
            </button> */}

                        {/* <BulkUploadModal
                            show={showBulkUploadModal}
                            onClose={closeBulkUploadModal}
                            columnDefs={locationMasterColumns}
                            screen={"location_master"}
                            templateUrl={require('../../assets/json/location_master_template.csv')}
                        /> */}
                         <CustomDialogForMasterEditLogs
                                    isOpen={editLogsModalOpen}
                                    onClose={handleCloseModal}
                                    editLogsData={editLogsData}
                                    filteredLog={filteredLog}
                                    setFilteredLog={setFilteredLog}
                                />

                        {Constants.VEHICLES.BTN_ADD === 1 && (
                            <button
                                className="btn btn-warning"
                                onClick={showAddBlock}
                                style={{ padding: "8px 15px", height: "35px" }}
                            >
                                <i className="icon-plus"></i>&nbsp;Add Transporter Allocation
                            </button>
                        )}
                    </div>
                </div>

                {/* Grid */}
                <div className="row">
                    <div className="col-xl-12 col-md-12 xl-60">
                        <div className="card">
                            <div className="card-body">
                            <div className="entity-form-group">
                            <label style={{ display: "block", marginBottom: "5px" , fontSize:"14px"}}>Select Entity<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={true}
                             value={entity.current}
                            // multi={true}
                            // className={"border-radius-0"} 
                            onChange={handleEntityWiseData}
                            options={validEntitiesOptions}
                            placeholder="Select Entity"
                            style={{ borderRadius: "0px" }}
                            styles={customStyles}
                            

                            >
                        </Select> 
                         
                        </div>
                                <div
                                    className="ag-theme-balham mt-3"
                                    style={{ height: "500px", width: "100%" }}
                                >
                                    <AgGridReact
                                    onCellEditingStarted={handleEditable}
                                        columnDefs={columnDefs}
                                        rowData={rowData}
                                        defaultColDef={defaultColDef}
                                        pagination={true}
                                        paginationPageSize={50}
                                        onGridReady={onGridReadyConsignments}
                                        enableRangeSelection={true}
                                        enableCellContextMenu={true}
                                        masterDetail={true}
                                        context={{ onClickEditBlock, onClickDeleteItem }}
                                        sideBar={{
                                            toolPanels: [
                                                {
                                                    id: "columns",
                                                    labelDefault: "Columns",
                                                    labelKey: "columns",
                                                    iconKey: "columns",
                                                    toolPanel: "agColumnsToolPanel",
                                                    toolPanelParams: {
                                                        suppressPivotMode: true,
                                                        suppressRowGroups: true,
                                                        suppressValues: true,
                                                    },
                                                },
                                                {
                                                    id: "filters",
                                                    labelDefault: "Filters",
                                                    labelKey: "filters",
                                                    iconKey: "filter",
                                                    toolPanel: "agFiltersToolPanel",
                                                },
                                            ],
                                        }}
                                        statusBar={{
                                            statusPanels: [
                                                {
                                                    statusPanel: "agTotalAndFilteredRowCountComponent",
                                                    align: "left",
                                                },
                                                {
                                                    statusPanel: "agTotalRowCountComponent",
                                                    align: "center",
                                                },
                                                { statusPanel: "agFilteredRowCountComponent" },
                                                { statusPanel: "agSelectedRowCountComponent" },
                                                { statusPanel: "agAggregationComponent" },
                                            ],
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className={"overlay-part " + (overlay)} onClick={hideAll}></div>

            <div className={"slide-r " + showAddSlider}>
                <div className="slide-r-title">
                    <h4 className="slide-r-title">{sliderText}
                        <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={hideAll} >X</span>

                    </h4>

                </div>
                <div className="slide-r-body">

                    <form className="" style={{ padding: "20px" }} onSubmit={saveMasterForm}>

                    <div className="form-group">
                            <label className="tpt-alloc-label">Source Pincode<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="consigner_pincode" value={transporter.consignerPincode} className='tpt-alloc-input'
                            autoComplete='off'
                            onChange={(e)=> 
                                setTransporter(prev=>({
                                    ...prev,
                                    consignerPincode:e.target.value
                                }))
                            }
                            maxLength={6}
                            required ={!isEditMode}

                            disabled={isEditMode}
                            />
                          {transporter.consignerPincode && !/^\d{6}$/.test(transporter.consignerPincode) && (
                                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                                Pincode must be exactly 6 digits
                                                            </span>
                                                            )}
                        </div>
                        <div className="form-group">
                            <label className="tpt-alloc-label">Source City<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="consigner_city" value={transporter.consignerCity} className='tpt-alloc-input'
                            autoComplete='off'
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(value)) {
                                  setTransporter(prev => ({
                                    ...prev,
                                    consignerCity: value
                                  }));
                                }
                              }}
                            required ={!isEditMode}


                            disabled={isEditMode}
                             />
                             
                        </div>
                        <div className="form-group">
                            <label className="tpt-alloc-label">Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="consignee_pincode" value={transporter.consigneePincode} className='tpt-alloc-input'
                            autoComplete='off'
                            onChange={(e)=> 
                                setTransporter(prev=>({
                                    ...prev,
                                    consigneePincode:e.target.value
                                }))
                            }
                            maxLength={6}
                            required ={!isEditMode}


                            disabled={isEditMode}
                             />
                              {transporter.consigneePincode && !/^\d{6}$/.test(transporter.consigneePincode) && (
                                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                                Pincode must be exactly 6 digits
                                                            </span>
                                                            )}
                        </div>
                        <div className="form-group">
                            <label className="tpt-alloc-label">Destination City<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="consigner_city" value={transporter.consigneeCity} 
                            className='tpt-alloc-input'
                            autoComplete='off'
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(value)) {
                                  setTransporter(prev => ({
                                    ...prev,
                                    consigneeCity: value
                                  }));
                                }
                              }}
                            required ={!isEditMode}


                            disabled={isEditMode}
                             />
                             
                        </div>

                        {isEditMode ?
                            <>
                                <div className="form-group" style={{ textAlign: "center" }}>
                                    <button type="submit" className="btn btn-success"
                                        style={{
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "4px",
                                            backgroundColor: "#28a745",
                                            color: "white",
                                        }}
                                    >Update Transporter Allocation</button>
                                </div>
                            </>
                            :
                            <>
                                <div className="form-group" style={{ textAlign: "center" }}>
                                    <button type="submit" className="btn btn-success"
                                        style={{
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "4px",
                                            backgroundColor: "#28a745",
                                            color: "white",
                                        }}
                                    >Add Transporter Allocation</button>
                                </div>
                            </>
                        }
                       

                    </form>
                </div>

            </div>
            {deleteConfirmationSlide
                &&
                <div className={"sliderBlock3 " + (deleteConfirmationSlide)} >
                    <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideDeleteSubmit} >
                        <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                    </span>
                    <div className='d-flex mt-60p' style={{ marginLeft: "42px" }}>
                        <div className='d-flex flex-column ml-20p'>
                            <h1 className='confirm-heading'>Are you sure you want to delete ?</h1>
                        </div>
                    </div>
                    <div className='d-flex flex-row ml-30p mt-20p'>
                        <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideDeleteSubmit} >Cancel</button>
                        <button className='btn_hover8' onClick={onsubmitdelete}>Delete</button>
                    </div>

                </div>}

            <div className={"dataLoadpage " + (showloader)}>
            </div>
            <div className={"dataLoadpageimg " + (showloader)}>
                <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part " + (overlay)} style={{ zIndex: "10" }}
            ></div>

        </div>
    );
}




export default Masters;
